import React, { useEffect, useState } from "react";
import { ArrowRight, BookOpen } from "lucide-react";
import { fetchStats } from "../lib/api";

export const Hero = () => {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    fetchStats().then(setStats).catch(() => setStats(null));
  }, []);

  return (
    <section
      id="top"
      className="section section--no-border"
      data-testid="hero"
      style={{ paddingTop: "5rem", paddingBottom: "4rem", position: "relative" }}
    >
      <div className="shell">
        <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem", maxWidth: 1100 }}>
          <span
            className="section__eyebrow"
            style={{ marginBottom: 0 }}
            data-testid="hero-eyebrow"
          >
            A living archive
          </span>
          <h1
            data-testid="hero-title"
            style={{
              fontFamily: "var(--font-display)",
              fontWeight: 500,
              maxWidth: 16 + "ch",
              fontStyle: "normal",
            }}
          >
            Will Not <em style={{ fontStyle: "italic", fontWeight: 400, color: "hsl(var(--accent))" }}>Be Forgotten</em>.
          </h1>
          <p
            data-testid="hero-lede"
            style={{
              fontFamily: "var(--font-display)",
              fontStyle: "italic",
              fontSize: "clamp(1.15rem, 1.55vw, 1.5rem)",
              lineHeight: 1.45,
              color: "hsl(var(--ink-soft))",
              maxWidth: 720,
              fontWeight: 400,
            }}
          >
            A public-memory project preserving the holidays, observances, and historic milestones that
            shape a fuller American story — and that are too often minimized, sanitized, or pushed to the margins.
          </p>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 12, marginTop: 8 }}>
            <a href="#explorer" className="btn btn--primary" data-testid="hero-cta-explore">
              Explore the Calendar <ArrowRight size={16} aria-hidden />
            </a>
            <a href="#why" className="btn btn--ghost" data-testid="hero-cta-why">
              <BookOpen size={16} aria-hidden /> Why These Dates Matter
            </a>
          </div>
        </div>

        <div
          aria-label="Archive at a glance"
          data-testid="hero-stats"
          style={{
            marginTop: "4rem",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
            gap: "1.5rem",
            paddingTop: "2rem",
            borderTop: "1px solid hsl(var(--line))",
          }}
        >
          {[
            { label: "Curated entries", value: stats?.total_entries ?? "—" },
            { label: "Federal holidays", value: stats?.federal_holidays ?? "—" },
            { label: "Heritage months", value: stats?.heritage_months ?? "—" },
            { label: "Historic anniversaries", value: stats?.anniversaries ?? "—" },
          ].map((s) => (
            <div key={s.label}>
              <div
                className="archival-figure"
                style={{
                  fontSize: "clamp(2rem, 3vw, 2.6rem)",
                  fontWeight: 500,
                  color: "hsl(var(--ink))",
                  lineHeight: 1,
                }}
              >
                {s.value}
              </div>
              <div style={{
                marginTop: 6,
                fontSize: "0.75rem",
                letterSpacing: "0.16em",
                textTransform: "uppercase",
                color: "hsl(var(--muted))",
              }}>
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
